<template>
  <div id="app">
    <div class="index-container">
      <Index />
    </div>
  </div>
</template>

<script>
import Index from './components/Index.vue'

export default {
  name: 'App',
  components: {
    Index
  },
  watch: {
    // 监听路由变化，只要切换就强制回顶
    '$route'() {
      // 方案1：优先处理 Index 内的 .main-content 容器（匹配你导航组件的滚动容器）
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        mainContent.scrollTop = 0;
        return;
      }
      // 方案2：兜底处理全局滚动（兼容所有情况）
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  /* overflow: hidden; */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
</style>